import { defineComponent } from "vue";

import { COMPONENT_NAME, SVG } from "./attributes";

export default defineComponent({
  name: COMPONENT_NAME,
  props: {
    title: {
      type: String,
      default: "",
    },
    isBig: {
      type: Boolean,
      default: false,
    },
    isCenter: {
      type: Boolean,
      default: false,
    },
  },
  emits: {
    close: null,
  },
  data() {
    return {
      resizeObserver: null as ResizeObserver | null,
    };
  },
  computed: {
    displayedCloseIcon(): string {
      return SVG.close;
    },
  },
  mounted(): void {
    const body = this.$refs.body as HTMLElement | undefined;
    const content = this.$refs.content as HTMLElement | undefined;
    if (!body || !content) return;

    // Выставляем стартовую высоту синхронно, до отрисовки, чтобы не было
    // анимации "из нуля" при первом открытии модалки.
    body.style.height = `${content.offsetHeight}px`;

    this.resizeObserver = new ResizeObserver(() => {
      body.style.height = `${content.offsetHeight}px`;
    });
    this.resizeObserver.observe(content);
  },
  beforeUnmount(): void {
    this.resizeObserver?.disconnect();
  },
  methods: {
    handleClose(): void {
      this.$emit("close");
    },
  },
});
